import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { fetchData, removeData } from "../../store/action"
import Cookie from "../../util/Cookie"
import isEmpty from "lodash/isEmpty"
import styled from "styled-components"
import uuid from "uuid"

const InnerContainer = styled.div`
  padding: 20px;
  width: 100%;
  box-sizing: border-box;
`
const UpperBox = styled.div`
  width: 100%;
  border-radius: 8px;
  background-color: #383d5a;
  height: 120px;
`

const uniqueId = uuid.v4()

const ProfileInfo = (props) => {
  const dispatch = useDispatch()
  const [accData, setAccData] = useState({})

  const userId = Cookie.get("X-Reycreo-Id")
  const operatorId = Cookie.get("X-Reycreo-Operator-Id")

  //   const [uniqueId, setUniqueId] = useState()

  useEffect(
    () => {
      //   setUniqueId(uuid.v4())
      if (userId && operatorId) {
        const msisdn = userId.split("BW_PH")
        dispatch(
          fetchData({
            uniqueId,
            method: "GET",
            uri: `/myAccount`,
            params: {
              msisdn: !isEmpty(msisdn) && msisdn[1],
              operatorId: operatorId,
            },
          })
        )
      } else {
        console.error("Unable to fetch due to lack of informations")
      }
      return () => {
        removeData({
          uniqueId,
        })
      }
    },
    [userId, operatorId]
  )

  let data = useSelector((state) => state)
  console.log("dataProfile", data)
  console.log("dataUnq", data.data)

  //   useEffect(
  //     () => {
  //       setAccData(data)
  //     },
  //     [data]
  //   )

  console.log("dataAcc", accData)
  console.log("dataAcc2", accData.data)
  if (data && data.data.uniqueId) {
    data.data = data.data.uniqueId
  }

  console.log("newData", data)

  //   if (!accData) {
  //     return null
  //   } else if (accData.undefined.error) {
  //     return <span>{accData.undefined.error}</span>
  //   }

  //   let { bidBalance = 0, status } = data.undefined.data
  //   if (!status) {
  //     status = "TRIAL"
  //   }

  //   const {
  //     bidBalance,
  //     expireBidCount,
  //     mobile,
  //     operator,
  //     status,
  //   } = data.undefined.data
  //   console.log("bidbalance", bidBalance)
  console.log("unqId", uniqueId)
  return (
    <div>
      <InnerContainer>
        <UpperBox>Rahul</UpperBox>
      </InnerContainer>
    </div>
  )
}

export default ProfileInfo



// WEBPACK FOOTER //
// ./src/views/MyAccount/ProfileInfo.js